
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Cancer_of_anal_canal',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Cancer_of_anal_canal.vue